export default interface ISonicMessage {
  id: string;
  roomId: string;
  senderId: string;
  senderName: string | null;
  sendDate: number;
  unreadUsers: Array<string>;
  message: string;
  img: string;
  relation?: string;
  relationOwner?: string;
  requestType?: "offer" | "project";
  title?: string;
}

export class SonicMessage implements ISonicMessage {
  id: string;
  roomId: string;
  senderId: string;
  senderName: string | null;
  sendDate: number;
  unreadUsers: Array<string>;
  message: string;
  img: string;
  relation?: string;
  relationOwner?: string;
  requestType?: "offer" | "project";
  title?: string;

  constructor(
    id: string,
    roomId: string,
    senderId: string,
    senderName: string | null,
    sendDate: number,
    unreadUsers: Array<string>,
    message: string,
    img: string,
    relation?: string,
    relationOwner?: string,
    requestType?: "offer" | "project",
    title?: string
  ) {
    this.id = id;
    this.roomId = roomId;
    this.senderId = senderId;
    this.senderName = senderName;
    this.sendDate = sendDate;
    this.unreadUsers = unreadUsers;
    this.message = message;
    this.img = img;
    this.relation = relation;
    this.relationOwner = relationOwner;
    this.requestType = requestType;
    this.title = title;
  }

  static parseFromAPIResponse(item: any) {
    return new SonicMessage(
      item.id,
      item.roomId,
      item.senderId,
      item.senderName,
      item.sendDate,
      item.unreadUsers,
      item.message,
      item.img,
      item.relation,
      item.relationOwner,
      item.requestType,
      item.title
    );
  }
}
